/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MicrosoftAspNetCoreMvcProblemDetails {
  [key: string]: any; // Allow additional fields if required
  type?: string;       // The problem type
  title?: string;      // A short, human-readable title for the problem
  status?: number;     // The HTTP status code
  detail?: string;     // Detailed error description
  instance?: string;   // The specific instance of the error
}
